import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatError } from "@/lib/api";
import { ChatList } from "@/components/whatsapp/ChatList";
import { ChatThread } from "@/components/whatsapp/ChatThread";

// صندوق وارد بتجربة واتساب: قائمة دردشات + محادثة. bot (اختياري): صندوق بوت عميل بدل صندوق رواج/حمد
export const WhatsAppInbox = ({ bot: tenant = null }) => {
  const base = tenant ? `/wa-bot/${tenant.id}/inbox` : "/wa/inbox";
  const botName = tenant ? (tenant.persona || "المساعد") : "حمد";
  const [data, setData] = useState({ contacts: [], bot: { enabled: true } });
  const [sel, setSel] = useState(null);
  const [thread, setThread] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    try { setData((await api.get(base)).data); } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
  }, [base]);
  const openThread = useCallback(async (id) => {
    if (!id) { setThread(null); return; }
    try {
      setThread((await api.get(tenant ? `${base}/${id}` : `${base}/${id}/messages`)).data);
      setData((d) => d && { ...d, contacts: d.contacts.map((c) => (c.wa_id === id && c.unread ? { ...c, unread: 0 } : c)) });  // الفتح = قراءة: أخفِ العداد فورًا
    } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
  }, [base, tenant]);

  useEffect(() => { load(); const t = setInterval(load, 10000); return () => clearInterval(t); }, [load]);
  useEffect(() => { openThread(sel); if (!sel) return undefined; const t = setInterval(() => openThread(sel), 6000); return () => clearInterval(t); }, [sel, openThread]);

  const send = async (text) => {
    setBusy(true);
    try { await api.post(`${base}/${sel}/reply`, { text }); await openThread(sel); await load(); return true; }
    catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); return false; } finally { setBusy(false); }
  };
  const sendMedia = async (file, caption) => {
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", file); fd.append("caption", caption || "");
      await api.post(`${base}/${sel}/media`, fd, { headers: { "Content-Type": "multipart/form-data" }, timeout: 120000 });
      await openThread(sel); await load(); return true;
    } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); return false; } finally { setBusy(false); }
  };
  const toggleContactBot = async (enabled) => {
    try { await api.post(`${base}/${sel}/bot`, { enabled }); await openThread(sel); await load(); } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
  };
  const toggleGlobalBot = async (enabled) => {
    try { await api.post("/wa/bot-settings", { enabled }); await load(); toast.success(enabled ? "حمد يرد الآن تلقائيًا" : "أوقفت الرد التلقائي"); } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
  };
  const resolve = async () => {
    try { await api.post(`${base}/${sel}/resolve`); await openThread(sel); await load(); } catch (e) { toast.error(formatError(e.response?.data?.detail || e.message)); }
  };

  const boxRef = React.useRef(null);
  React.useEffect(() => {  // على الجوال المحادثة تغطي الشاشة — نقفل تمرير الصفحة خلفها حتى لا «تعلق» اللمسات بين طبقتين
    const mobile = sel && window.innerWidth < 768;
    document.body.style.overflow = mobile ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [sel]);
  const select = (id) => { setSel(id); if (window.innerWidth >= 768) boxRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }); };

  const subtitle = `${data.contacts.length} دردشة · ${data.contacts.reduce((a, c) => a + (c.unread || 0), 0)} غير مقروءة · ${data.needs_human || 0} تحتاج موظفًا${tenant?.display_phone ? ` · ${tenant.display_phone}` : ""}`;

  return (
    <div ref={boxRef} className="rounded-3xl border border-border overflow-hidden h-[calc(100dvh-120px)] min-h-[480px] md:grid md:grid-cols-[340px_1fr] relative scroll-mt-4" data-testid="wa-inbox">
      <div className={`h-full min-h-0 md:border-e border-border ${sel ? "hidden md:flex md:flex-col" : "flex flex-col"}`}>
        <ChatList contacts={data.contacts} sel={sel} onSelect={select} title={tenant ? "الدردشات" : "دردشات واتساب"} subtitle={subtitle}
          emptyText={tenant && !tenant.display_phone ? "بعد ربط رقم واتساب نشاطك ستظهر دردشات عملائك هنا." : "لا دردشات بعد — أول رسالة تصل إلى رقم واتساب ستظهر هنا."}
          onRefresh={() => { load(); openThread(sel); }} globalBot={!tenant ? !!data.bot?.enabled : undefined} onGlobalBot={!tenant ? toggleGlobalBot : undefined} />
      </div>
      <div className={`min-h-0 ${sel ? "fixed inset-0 z-[70] flex flex-col bg-background h-[100dvh] md:static md:z-auto md:h-full" : "hidden md:flex md:flex-col md:h-full"}`}>
        <ChatThread thread={sel ? thread : null} botName={botName} busy={busy} onBack={() => setSel(null)} onSend={send} onSendMedia={sendMedia} onToggleBot={toggleContactBot} onResolve={resolve} />
      </div>
    </div>
  );
};
